import { render, staticRenderFns } from "./loanHistory.vue?vue&type=template&id=632fcf78"
import script from "./loanHistory.vue?vue&type=script&lang=js"
export * from "./loanHistory.vue?vue&type=script&lang=js"
import style0 from "./loanHistory.vue?vue&type=style&index=0&id=632fcf78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports